import { AxiosError } from 'axios'
import flagsmith from 'flagsmith'
import Cookies from 'js-cookie'

import { ApiError } from '@/lib/axios'
import { COOKIES_KEYS } from '../constants/cookiesKeys'
import { ROUTES } from '../constants/routes'

export class ResponseErrorInterceptors {
  private error: AxiosError<ApiError>

  constructor(error: AxiosError<ApiError>) {
    this.error = error
  }

  disconnectUser() {
    if (this.error?.status === 401) {
      window.location.replace(ROUTES.LOGIN.DISCONNECTED)

      Cookies.remove(COOKIES_KEYS.token)

      flagsmith.logout()
    }

    return this
  }

  build() {
    return Promise.reject(this.error)
  }
}
